import { usePage } from "@inertiajs/react";
import type { SharedData } from "@/types";

export function AppVersion() {
  const { config } = usePage<SharedData>().props;

  if (!config.appVersion) {
    return null;
  }

  return (
    <div className="absolute bottom-4 left-4 text-muted-foreground/80 text-xs">
      <span>{config.appVersion}</span>
    </div>
  );
}
